export default "__VITE_ASSET__875cb0e9__"